import privateInstance from "../privateClient";
import { FetchCompanyDetailsQueryType } from "./types";

export const companyApi = {
  getCompanyDetails: async () => {
    try {
      const response =
        await privateInstance.get<FetchCompanyDetailsQueryType["Data"]>(
          "/company-details",
        );

      return response.data;
    } catch (err) {
      return null;
    }
  },
};
